module.exports = __webpack_public_path__ + "img/bbps.c5e6e602.png";